class SiteConfig {
    static SITE_DOMAIN = "https://stg-registry.carbonpumpit.co";
    
    static BACKEND_DOMAIN = "https://stg-api.carbonpumpit.co";
    
    static PLEDGES_PDF_DOMAIN = "https://stg-pledges.carbonpumpit.co";
    
    static COGNITO_CLIENT_ID = "uncfkh6mf62lqi1kjfh6l1749";
    static COGNITO_DOMAIN = "https://cp.auth.eu-west-1.amazoncognito.com";
    static COGNITO_AUTHORITY = "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_ZAn0QVMcW";
    static COGNITO_LOGOUT_URI = `${this.COGNITO_DOMAIN}/logout?client_id=${this.COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(this.SITE_DOMAIN)}`
    
    static BLOCKCHAIN_SMART_CONTRACT = "0x8FFdf5B20C17c45f0Aed23EBc68AAe66ED12aFCf";
    static BLOCKCHAIN_GAS_STATION_URL = "https://gasstation-testnet.polygon.technology/v2";
    
    static SENTRY_ENVIRONMENT = "staging";
}

export default SiteConfig;